import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { Routes } from "@angular/router";

import SwiperCore, { Navigation, Pagination } from 'swiper';


import { LocalizationModule, SharedModule } from 'src/core/index/shared.module.index';
import { AuthGuard } from "src/index/services.index";
import { FaqsComponent, FaqsListComponent } from "src/index";

SwiperCore.use([Navigation, Pagination]);

const routes: Routes = [ // Rotte definite ma RoutingModule non configurato, per poter gestire eventuale override da app esterna
    {
        path: 'faqs',
        canActivate: [AuthGuard],
        component: FaqsComponent,
    }
];

@NgModule({
    declarations: [
        FaqsComponent,
        FaqsListComponent,
    ],
    imports: [
        CommonModule,
        LocalizationModule,
        SharedModule,
    ],
    providers: [
        AuthGuard,
    ],
    exports: [
        FaqsComponent,
        FaqsListComponent,
    ],
})
export class FaqsModule {
    getRoutes() {
        return routes;
    }
}
